import JobOfferEditor from "./JobOfferEditor";

export default JobOfferEditor;
